import { useMutation } from "@pinia/colada";

import { useCompanyStore } from "@/entities/company/model";
import { useWidgetContext } from "@/shared/config";
import { useApiGetWidgetData } from "@/shared/model";

import { type B2bLeadDevice, apiCreateB2bLead } from "../api";

/** Отправить список техники вместе с контактами компании, которые сохранены на прошлом шаге */
export function useApiCreateB2bLead() {
    const { settings } = useWidgetContext();
    const { data: widgetData } = useApiGetWidgetData();
    const companyStore = useCompanyStore();

    return useMutation({
        mutation: ({ file, device }: { file: File; device: B2bLeadDevice }) =>
            apiCreateB2bLead({
                calcApiToken: widgetData.value?.token ?? "",
                companyName: companyStore.contacts.companyName,
                firstName: companyStore.contacts.firstName,
                lastName: companyStore.contacts.lastName,
                email: companyStore.contacts.email,
                phone: companyStore.phoneDigits,
                locale: settings.locale,
                countryCode: widgetData.value?.location ?? "",
                file,
                ...device,
            }),
    });
}
